import type { PropsWithChildren } from 'react'

import { GoogleOAuthProvider } from '@react-oauth/google'

import { GOOGLE_SIGNUP_CLIENT_ID } from '@constants'

export const GoogleAuthGate = ({ children }: PropsWithChildren) =>
  GOOGLE_SIGNUP_CLIENT_ID ? (
    <GoogleOAuthProvider clientId={GOOGLE_SIGNUP_CLIENT_ID}>{children}</GoogleOAuthProvider>
  ) : (
    <>{children}</>
  )
